import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-58baaa63"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "param-setting"
};
const _hoisted_2 = {
  class: "page-header"
};
const _hoisted_3 = {
  class: "desc-tip"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "desc-tip__text"
}, [/*#__PURE__*/_createTextVNode(" 支持动态配置 "), /*#__PURE__*/_createElementVNode("em", null, "栏目"), /*#__PURE__*/_createTextVNode(" 、 "), /*#__PURE__*/_createElementVNode("em", null, "模块"), /*#__PURE__*/_createTextVNode(" 和 "), /*#__PURE__*/_createElementVNode("em", null, "参数"), /*#__PURE__*/_createTextVNode(" ；参数编码首次填写后 "), /*#__PURE__*/_createElementVNode("em", null, "锁定不可编辑"), /*#__PURE__*/_createTextVNode(" 。 ")], -1));
const _hoisted_5 = {
  class: "card"
};
const _hoisted_6 = {
  class: "panel"
};
const _hoisted_7 = {
  key: 0,
  class: "empty"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "empty__text"
}, "暂无栏目，点击上方「+ 新增栏目」开始配置", -1));
import { onMounted, ref } from 'vue';
import { InboxOutlined, InfoCircleFilled } from '@ant-design/icons-vue';
import { reportEvent } from '@/common';
import ColumnTabs from './components/ColumnTabs.vue';
import ModuleList from './components/ModuleList.vue';
import ModuleEditModal from './components/ModuleEditModal.vue';
import ModuleMoveModal from './components/ModuleMoveModal.vue';
import ParamEditModal from './components/ParamEditModal.vue';
import ParamLogModal from './components/ParamLogModal.vue';
import BackTop from '@/components/BackTop.vue';
import { useParamSetting } from './hooks/useParamSetting';
/** 业务名常量，所有 element_use 埋点 ui_name 复用 */
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    /**
     * 参数配置 - 主页面
     *
     * 职责：
     * - 顶部 desc-tip 信息提示
     * - 嵌入 ColumnTabs（栏目导航）+ ModuleList（模块/参数渲染）
     * - 挂载 ModuleEditModal / ParamEditModal 两个弹窗
     * - 把子组件 emit 上来的事件转交给 useParamSetting hook 做数据变更
     * - 在动作成功后上报 element_use 埋点
     *
     * 数据流：UI 组件 → handleXxx 包装层 → hook 方法 → 接口
     * 埋点策略：
     * - 页面打开（ui_open）由全局 Sider/Store 自动上报，此处不重复
     * - 用户行为（element_use）在接口成功后才上报，避免失败也算
     * - 接口查询（_search）在 hook 内统一上报
     */
    const UI_NAME = '参数配置';
    const {
      // 状态
      columns,
      activeColumnId,
      paramsByModule,
      currentModules,
      isColumnsEmpty,
      loadingColumns,
      loadingContent,
      // 方法
      loadColumns,
      switchColumn,
      createColumn,
      removeColumn,
      saveModule,
      removeModule,
      moveModule,
      reorderModules,
      saveParam,
      removeParam,
      fetchSourceOptions
    } = useParamSetting();
    onMounted(() => {
      loadColumns();
    });
    /** 通用 element_use 埋点（仅在动作成功后调用） */
    const trackElement = elementName => {
      reportEvent({
        eventName: 'element_use',
        properties: {
          ui_name: UI_NAME,
          element_name: elementName
        }
      });
    };
    // ===== 栏目交互 =====
    /** 切换栏目（用户主动行为，立即上报） */
    const handleSwitchColumn = async columnId => {
      trackElement('切换栏目');
      await switchColumn(columnId);
    };
    const handleCreateColumn = async name => {
      const ok = await createColumn(name);
      if (ok) trackElement('新增栏目');
      return ok;
    };
    const handleRemoveColumn = async columnId => {
      const ok = await removeColumn(columnId);
      if (ok) trackElement('删除栏目');
      return ok;
    };
    // ===== 模块交互 =====
    // 新增 / 编辑弹窗
    const moduleModalVisible = ref(false);
    const editingModule = ref(null);
    // 移动弹窗（独立）
    const moveModalVisible = ref(false);
    const movingModule = ref(null);
    /** 打开新增模块弹窗 */
    const handleAddModule = () => {
      editingModule.value = null;
      moduleModalVisible.value = true;
    };
    /** 打开编辑模块弹窗（只能改名称 / 编码） */
    const handleEditModule = m => {
      editingModule.value = m;
      moduleModalVisible.value = true;
    };
    /** 打开移动模块弹窗（只切换所属栏目） */
    const handleMoveModule = m => {
      movingModule.value = m;
      moveModalVisible.value = true;
    };
    const handleDeleteModule = async m => {
      const ok = await removeModule(m.id, m.columnId);
      if (ok) trackElement('删除模块');
      return ok;
    };
    const handleReorderModules = async orderedIds => {
      if (activeColumnId.value == null) return false;
      const ok = await reorderModules(activeColumnId.value, orderedIds);
      if (ok) trackElement('模块拖拽排序');
      return ok;
    };
    /**
     * 编辑 / 新增模块弹窗提交
     * 只更新名称 / 编码 / sortOrder；归属变更走独立的移动弹窗
     */
    const handleSubmitModule = async payload => {
      const ok = await saveModule(payload);
      if (ok) trackElement(payload.id == null ? '新增模块' : '编辑模块');
      return ok;
    };
    /**
     * 移动模块弹窗提交
     * 复用 /setting/module/save，columnId 改为目标栏目 id
     */
    const handleSubmitMove = async payload => {
      const ok = await moveModule(payload.moduleId, payload.fromColumnId, payload.targetColumnId);
      if (ok) trackElement('移动模块');
      return ok;
    };
    // ===== 参数交互 =====
    const paramModalVisible = ref(false);
    const editingParam = ref(null);
    /** 当前操作所属模块 id，用于弹窗提交时回填 moduleId */
    const paramModuleId = ref(null);
    /** 当前操作所属模块名，仅用于弹窗顶部归属信息展示 */
    const paramModuleName = ref('');
    /** 当前操作所属栏目名，仅用于弹窗顶部归属信息展示 */
    const paramColumnName = ref('');
    const resolveColumnName = columnId => {
      var _columns$value$find;
      if (columnId == null) return '';
      return ((_columns$value$find = columns.value.find(c => c.id === columnId)) === null || _columns$value$find === void 0 ? void 0 : _columns$value$find.columnName) || '';
    };
    const handleParamAdd = m => {
      editingParam.value = null;
      paramModuleId.value = m.id;
      paramModuleName.value = m.moduleName || '';
      paramColumnName.value = resolveColumnName(m.columnId);
      paramModalVisible.value = true;
    };
    const handleParamEdit = payload => {
      editingParam.value = payload.param;
      paramModuleId.value = payload.module.id;
      paramModuleName.value = payload.module.moduleName || '';
      paramColumnName.value = resolveColumnName(payload.module.columnId);
      paramModalVisible.value = true;
    };
    // 日志弹窗
    const logModalVisible = ref(false);
    const logParam = ref(null);
    const handleParamLog = payload => {
      logParam.value = payload.param;
      logModalVisible.value = true;
      trackElement('查看参数日志');
    };
    const handleParamDelete = async payload => {
      const ok = await removeParam(payload.param.id, payload.module.id);
      if (ok) trackElement('删除参数');
      return ok;
    };
    const handleSubmitParam = async payload => {
      const ok = await saveParam(payload);
      if (ok) trackElement(payload.id == null ? '新增参数' : '编辑参数');
      return ok;
    };
    return (_ctx, _cache) => {
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(InfoCircleFilled), {
        class: "desc-tip__icon"
      }), _hoisted_4])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_a_spin, {
        spinning: _unref(loadingColumns)
      }, {
        default: _withCtx(() => [_createVNode(ColumnTabs, {
          columns: _unref(columns),
          "active-id": _unref(activeColumnId),
          "on-add-column": handleCreateColumn,
          "on-delete-column": handleRemoveColumn,
          onChange: handleSwitchColumn
        }, null, 8, ["columns", "active-id"])]),
        _: 1
      }, 8, ["spinning"]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_a_spin, {
        spinning: _unref(loadingContent)
      }, {
        default: _withCtx(() => [_unref(isColumnsEmpty) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_unref(InboxOutlined), {
          class: "empty__icon"
        }), _hoisted_8])) : (_openBlock(), _createBlock(ModuleList, {
          key: 1,
          modules: _unref(currentModules),
          "params-by-module": _unref(paramsByModule),
          onAdd: handleAddModule,
          onEdit: handleEditModule,
          onMove: handleMoveModule,
          onDelete: handleDeleteModule,
          onReorder: handleReorderModules,
          onParamAdd: handleParamAdd,
          onParamEdit: handleParamEdit,
          onParamLog: handleParamLog,
          onParamDelete: handleParamDelete
        }, null, 8, ["modules", "params-by-module"]))]),
        _: 1
      }, 8, ["spinning"])])]), _createVNode(ModuleEditModal, {
        visible: moduleModalVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => moduleModalVisible.value = $event),
        module: editingModule.value,
        "default-column-id": _unref(activeColumnId),
        "current-modules-count": _unref(currentModules).length,
        "on-submit": handleSubmitModule
      }, null, 8, ["visible", "module", "default-column-id", "current-modules-count"]), _createVNode(ModuleMoveModal, {
        visible: moveModalVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = $event => moveModalVisible.value = $event),
        module: movingModule.value,
        columns: _unref(columns),
        "on-submit": handleSubmitMove
      }, null, 8, ["visible", "module", "columns"]), _createVNode(ParamEditModal, {
        visible: paramModalVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = $event => paramModalVisible.value = $event),
        param: editingParam.value,
        "module-id": paramModuleId.value,
        "module-name": paramModuleName.value,
        "column-name": paramColumnName.value,
        "fetch-source-options": _unref(fetchSourceOptions),
        "on-submit": handleSubmitParam
      }, null, 8, ["visible", "param", "module-id", "module-name", "column-name", "fetch-source-options"]), _createVNode(ParamLogModal, {
        visible: logModalVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = $event => logModalVisible.value = $event),
        param: logParam.value
      }, null, 8, ["visible", "param"]), _createVNode(BackTop, {
        onClick: _cache[4] || (_cache[4] = () => trackElement('一键置顶'))
      })]);
    };
  }
});